export default __webpack_public_path__ + "static/media/icon-flag-france.dcf14823.svg";